import { Select, MenuItem, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import IT from "country-flag-icons/react/3x2/IT";
import GB from "country-flag-icons/react/3x2/GB";
import DE from "country-flag-icons/react/3x2/DE";

export function LanguageSelector() {
  const { i18n } = useTranslation();

  return (
    <Select
      value={i18n.language.startsWith("en") ? "en" : i18n.language.startsWith("de") ? "de" : "it"}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      size="small"
      variant="standard"
      disableUnderline
      sx={{
        fontSize: "0.85rem",
        color: "#444",
        "& .MuiSelect-select": { py: 0, pr: "20px !important" },
        "& .MuiSvgIcon-root": { fontSize: "1rem" },
      }}
    >
      <MenuItem value="it"><Box component={IT} sx={{ width: 20, mr: 0.5, verticalAlign: "middle" }} /> IT</MenuItem>
      <MenuItem value="en"><Box component={GB} sx={{ width: 20, mr: 0.5, verticalAlign: "middle" }} /> EN</MenuItem>
      <MenuItem value="de"><Box component={DE} sx={{ width: 20, mr: 0.5, verticalAlign: "middle" }} /> DE</MenuItem>
    </Select>
  );
}
